const supportedContentTypes = [
  "Promotional",
  "Educational",
  "Informational",
  "Product",
  "Service",
  "Testimonial",
  "Case Study",
  "Behind the Scenes",
  "FAQ",
  "Poll",
  "Engagement",
  "Festival",
  "Seasonal",
  "Offer",
  "Brand Story",
  "User Generated Content",
  "Tips"
];

export default supportedContentTypes;
